import { render } from "./Vaults.vue?vue&type=template&id=f9bc472e&scoped=true&ts=true"
import script from "./Vaults.vue?vue&type=script&lang=ts"
export * from "./Vaults.vue?vue&type=script&lang=ts"

import "./Vaults.vue?vue&type=style&index=0&id=f9bc472e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9bc472e"]])

export default __exports__